import { apiPaths } from '../config/apiPaths';
import { ProductCategoryResponse } from '../modules/Reports/model/ProductCategoryResponse';
import axiosInstance from './axios';

export const getProductCategories = (): Promise<ProductCategoryResponse[]> =>
  axiosInstance.get<ProductCategoryResponse[]>(apiPaths.PRODUCT_CATEGORIES, {}).then(({ data }) => data);
